import { IssuerConfirmTransferData } from '@/modules/issuer-dashboard/components/modals/IssuerConfirmTransferModal.tsx';
import { useIssuerTransferByIdQuery } from '@/modules/issuer-dashboard/queries/transfers.tsx';
import { BaseModalProps, ModalContentWrapper, Spinner } from 'ui';

export interface IssuerConfirmTransferWithLoadByIdModalProps extends BaseModalProps {
  transferId: number;
  isDeleted?: boolean;
}

export const IssuerConfirmTransferWithLoadByIdModal = ({
  open,
  transferId,
  onClose,
  isDeleted,
}: IssuerConfirmTransferWithLoadByIdModalProps) => {
  const { data: dataTransfer, isLoading } = useIssuerTransferByIdQuery({
    id: transferId,
    is_deleted: isDeleted,
  });

  return (
    <ModalContentWrapper open={open} title="Confirm transfer" onClose={onClose}>
      {isLoading || !dataTransfer?.transfer ? (
        <div className="w-full flex flex-col items-center justify-center h-full min-h-[200px]">
          <Spinner size="md" />
        </div>
      ) : (
        <IssuerConfirmTransferData {...dataTransfer?.transfer} onClose={onClose} open={open} />
      )}
    </ModalContentWrapper>
  );
};
